<template>
  <div class="main-body-wrapper">
    <div class="header-wrapper">
      <Header v-if="!isMobile" />
      <Notifications v-if="isMobile && !isMobileLandscapeCal" />
    </div>
    <slot />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/header.vue';
import Footer from '@/components/footer.vue';
import Notifications from '@/components/notification';
import { mapActions, mapGetters } from 'vuex';
import { isMobile } from 'mobile-device-detect';

export default {
  components: {
    Header,
    Footer,
    Notifications,
  },
  data: () => {
    return {
      inputPanelScaleRatio: 1,
      isMobile,
    };
  },
  computed: {
    ...mapGetters({
      ratio: 'general/inputPanelScaleRatio',
    }),
    isMobileLandscapeCal() {
      return isMobile && this.$screen.width > this.$screen.height;
    },
  },
  methods: {
    ...mapActions({
      updateGeneral: 'general/updateGeneral',
    }),
    calInputPanelScaleRatio() {
      const divider = !isMobile || this.isMobileLandscapeCal ? this.$screen.width * 0.5 : this.$screen.width;
      this.inputPanelScaleRatio = Math.min(divider / 500, 1);
    },
  },
  watch: {
    '$screen.width': {
      handler(val) {
        this.calInputPanelScaleRatio();
        const inputPanelScaleRatio = { ...this.ratio };
        if (!isMobile || this.isMobileLandscapeCal) {
          inputPanelScaleRatio.landscape = this.inputPanelScaleRatio;
        } else {
          inputPanelScaleRatio.vertical = this.inputPanelScaleRatio;
        }

        this.updateGeneral({
          inputPanelScaleRatio,
        });
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.main-body-wrapper {
  height: 100%;
  width: 100%;

  .header-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    max-width: 1400px;
    z-index: 10;
    background-color: $ga-navy-900;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);

    /*
     * v2.1 mobile ticker: a 30px bar, 16px gold icons from a 10px gutter, a
     * divider, then the marquee. Scoped to this header so the v1 desktop
     * right panel keeps its own ticker.
     */
    .notification-container {
      height: 30px;
      margin-right: 0;
      color: $ga-text-default;
      font-weight: 500;

      img {
        width: 16px;
        height: 16px;
      }

      .lobby-trigger,
      .schedule-trigger,
      .notification-trigger {
        top: 7px;
        height: 16px;
      }

      .lobby-trigger {
        left: 10px;
        border-right-color: rgba(255, 255, 255, 0.18);
      }

      .schedule-trigger {
        left: 36px;
      }

      .notification-trigger {
        left: 62px;
      }

      .marquee {
        padding-left: 98px;
      }

      &.no-lobby {
        .schedule-trigger {
          left: 10px;
        }

        .notification-trigger {
          left: 36px;
        }

        .marquee {
          padding-left: 72px;
        }
      }

      .schedule-trigger .icon-schedule,
      .lobby-trigger {
        padding-right: 0;
        margin-right: 0;
        border-right: 0;
      }

      // The divider between the icons and the text.
      &::after {
        content: '';
        position: absolute;
        top: 8px;
        left: 62px;
        width: 1px;
        height: 14px;
        background-color: rgba(255, 255, 255, 0.18);
      }

      &:not(.no-lobby)::after {
        left: 88px;
      }
    }
  }
}
</style>
